import { gql } from '@apollo/client';

export const CREATE_PAYMENT = gql`
  mutation CreatePayment(
    $serviceId: String!
    $targetId: ID
    $paymentMethod: PaymentMethodEnum!
    $cardId: ID
    $amount: Float
    $source: SourceEnum!
    $referrer: PaymentReferrerEnum
  ) {
    createPayment(
      serviceId: $serviceId
      targetId: $targetId
      paymentMethod: $paymentMethod
      cardId: $cardId
      amount: $amount
      source: $source
      referrer: $referrer
    ) {
      entity {
        redirectUrl
        status
        paymentLegacyId
        paymentDate
        targetLegacyId
        provider
      }
      errors {
        code
        message
        path
      }
    }
  }
`;

export const CREATE_TERMINAL_PAYMENT = gql`
  mutation CreateTerminalPayment($serviceId: String!, $targetId: ID!) {
    createTerminalPayment(serviceId: $serviceId, targetId: $targetId) {
      entity
      errors {
        code
        message
        path
      }
    }
  }
`;

export const PAY_FOR_AD_BY_PREPAID_BUNDLE = gql`
  mutation PayForAdByPrepaidBundle($adId: ID!) {
    payForAdByPrepaidBundle(adId: $adId) {
      entity
      errors {
        code
        message
        path
      }
    }
  }
`;
